<template>
  <form>
    <div
      class="modal-card"
      style="width: auto">
      <header class="modal-card-head">
        <p
          class="modal-card-title">
          <translate>Lägg till ny fångst</translate>
        </p>
      </header>
      <section
        v-if="teams"
        class="modal-card-body">
        <b-field
          :label="$gettext('Lag')">
          <b-select
            v-model="thiscatch.team"
            :placeholder="$gettext('Välj Lag')">
            <option
              v-for="thisteam in sortedTeams"
              :key="thisteam.pk"
              :value="thisteam.pk">
              {{ thisteam.number }} - {{ thisteam.name }}
            </option>
          </b-select>
        </b-field>
        <b-field
          :label="$gettext('Vikt i kg')">
          <b-input
            v-model="thiscatch.weight"
            type="string"
            pattern="[0-9]+([,\.][0-9]+)?"
            :placeholder="$gettext('Fångstens vikt')"
            required />
        </b-field>
        <b-field
          :label="$gettext('Längd i cm')">
          <b-input
            v-model="thiscatch.length"
            type="string"
            pattern="[0-9]+([,\.][0-9]+)?"
            :placeholder="$gettext('Fångstens längd')"
            required />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary"
          @click="save">
          <translate>Spara</translate>
        </button>
      </footer>
    </div>
  </form>
</template>


<script>
import { catchService, competitionService, teamService, countryService, dayService } from '../../_services';

export default {
  name: 'EditCatch',
  props: {
    id: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      day: undefined,
      countries: undefined,
      teams: undefined,
      country: undefined,
      weight: undefined,
    }
  },
  computed: {
    sortedTeams: function() {
      function compare(a, b) {
        if (a.number < b.number)
          return -1;
        if (a.number > b.number)
          return 1;
        return 0;
      }
      // eslint-disable-next-line
      return this.teams.sort(compare);
    }
  },
  async created() {
    var self = this
    self.thiscatch = await catchService.get(self.id)
    self.thiscatch.length = self.thiscatch.length.toString().replace(".", ",")
    self.thiscatch.weight = self.thiscatch.weight.toString().replace(".", ",")
    self.day = await dayService.get(self.thiscatch.day)
    self.competition = await competitionService.get(self.day.competition)
    self.countries = await countryService.getAll()
    self.teams = await teamService.getAll(self.day.competition)
  },
  methods: {
    save: async function(){
      var self = this
      console.log(self.thiscatch)
      self.thiscatch.weight = parseFloat(self.thiscatch.weight.replace(",", "."))
      self.thiscatch.length = parseFloat(self.thiscatch.length.replace(",", "."))
      await catchService.put(self.id, self.thiscatch)
    }
  },
}
</script>
